// extracted by mini-css-extract-plugin
export default {"root":"Exercise_root__2X09S","close":"Exercise_close__8+Rfu"};